var ChipBadgeTypes;
(function (ChipBadgeTypes) {
    ChipBadgeTypes["Plus"] = "plus";
    ChipBadgeTypes["Pro"] = "pro";
})(ChipBadgeTypes || (ChipBadgeTypes = {}));
var ChipSkins;
(function (ChipSkins) {
    ChipSkins["Default"] = "default";
    ChipSkins["Primary"] = "primary";
    ChipSkins["Secondary"] = "secondary";
    ChipSkins["Tertiary"] = "tertiary";
    ChipSkins["Positive"] = "positive";
    ChipSkins["Negative"] = "negative";
    ChipSkins["Success"] = "success";
    ChipSkins["Warning"] = "warning";
    ChipSkins["Error"] = "error";
})(ChipSkins || (ChipSkins = {}));

export { ChipBadgeTypes, ChipSkins };
